import React, { useRef, useEffect, useCallback, useState} from 'react';
import {
    setSelectedPianoRollSteps,
} from 'actions/index.js';
import TrackOutputType from 'components/track/TrackOutputType.js';
import TrackSend from 'components/effects/TrackSend.js';
import PanningComponent from './PanningComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import AddEffect from 'components/effects/AddEffect.js';
import {addEffect} from 'operations/actions.js';
import {getInstrumentComponent} from './getInstrumentComponent.js';
import MidiEffectComponent from './MidiEffectComponent.js';
import LiveEffectComponent from './LiveEffectComponent.js';
import EffectComponent from './EffectComponent.js';
import {connect} from 'react-redux';

const EffectsView = ({
    isFrozen,
    sends,
    track,
    scrollContainer,
    sequencerEngine,
    panning,
    hideLock,
    _liveFx,
    _audioFx,
    _midiFx,
    isRack,
    pulledEffects,
    setSelectedSteps,
}) => { 
    const ref = useRef(undefined);

    let [effects, setEffects] = useState(track.effects);
    let [midiEffects, setMidiEffects] = useState(track.midiEffects.effects);
    let [liveEffects, setLiveEffects] = useState(track.liveEffects.effects);
    let sendNodes = track.getSendNodes();

    let instrument = '' ; /*isFrozen ? '' : getInstrumentComponent(
        track,
        [scrollContainer, ref]) || '';*/

    const handleChooseMidiEffect = useCallback((effect) => {
        sequencerEngine.operationManager.dispatch(
            addEffect(effect, track));
        setMidiEffects([... track.midiEffects.effects]);
    }, [track, setMidiEffects]);

    const handleChooseLiveEffect = useCallback((effect) => {
        track.liveEffects.addEffect(effect);
        setLiveEffects([... track.liveEffects.effects]);
    }, [track, setLiveEffects]);

    const handleChooseEffect = useCallback((effect) => {
        effect.enable(true);
        sequencerEngine.operationManager.dispatch(
            addEffect(effect, track));
        setEffects([... track.effects]);
    }, [track, setEffects]);

    const onChangePanning = useCallback((panning) => {
        track.setPanning(panning);
    }, [track]);

    const onDeleteEffect = useCallback(() => {
        setEffects([... track.effects]);
        setMidiEffects([... track.midiEffects.effects]);
        setLiveEffects([... track.liveEffects.effects]);
    }, [track, setEffects, setMidiEffects, setLiveEffects]);

    useEffect(() => {
        setSelectedSteps([]);
    }, []);

    if (effects === undefined ||
        liveEffects === undefined ||
        midiEffects === undefined) {
        return (
            <div></div>
        );
    }

    let {tracks} = sequencerEngine;
    const onEffectsChange = () => {};
    let className = "effects-view";
    if (isRack) {
        className += " effects-view-instrument-rack";
    }
    let _liveEffects = (track && track.liveEffects && track.liveEffects.effects) || [];
    let _midiEffects = (track && track.midiEffects && track.midiEffects.effects) || [];
    let _effects = (track && track.effects) || [];
    return (
        <div
          ref={ref}
          className={className}>
          {_liveEffects.map(
              (effect, i) =>
                  <LiveEffectComponent
                    key={i}
                    scrollContainer={[scrollContainer, ref]}
                    sequencerEngine={sequencerEngine}
                    onDeleteEffect={onDeleteEffect}
                    isPulled={pulledEffects.includes(effect)}
                    effect={effect}
                    track={track}
                    tracks={tracks}
                    onEffectsChange={onEffectsChange}/>)}
          {instrument}
              {_midiEffects.map(
                  (effect, i) =>
                      <MidiEffectComponent
                        key={i}
                        sequencerEngine={sequencerEngine}
                        isPulled={pulledEffects.includes(effect)}
                        scrollContainer={[scrollContainer, ref]}
                        onDeleteEffect={onDeleteEffect}
                        effect={effect}
                        track={track}
                        tracks={tracks}
                        onEffectsChange={onEffectsChange}/>)}
              {_effects.map(
                  (effect, i) =>
                      <EffectComponent
                        sequencerEngine={sequencerEngine}
                        isPulled={pulledEffects.includes(effect)}
                        scrollContainer={[scrollContainer, ref]}
                        key={i}
                        onDeleteEffect={onDeleteEffect}
                        effect={effect}
                        track={track}
                        tracks={tracks}
                        onEffectsChange={onEffectsChange}/>)}
                <AddEffect
                  track={track}
                  sequencerEngine={sequencerEngine}
                  addClassName="add-track-effects-button"
                  handleChooseMidiEffect={handleChooseMidiEffect} 
                  handleChooseLiveEffect={handleChooseLiveEffect} 
                  handleChooseEffect={handleChooseEffect}
                  store={sequencerEngine.store}/>
          <div className="sends-and-options-container">
            <div className="sends-container">
              {sendNodes.map(
                  (sendNode, i) =>
                      <TrackSend
                        key={"track-send-" + i}
                        track={track}
                        sequencerEngine={sequencerEngine}
                        sendNumber={i}
                        send={sends.getSends()[i]}
                        sendNode={sendNode}/>)}
              <PanningComponent
                panning={panning}
                onChangePanning={onChangePanning}/>
            </div>
            {track ? <TrackOutputType track={track}/> : ''}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        isFrozen: props.track.isFrozen,
        effectsLen: props.track.effects && props.track.effects.length,
        midiEffectsLen: props.track.midiEffects.effects && props.track.midiEffects.effects.length,
        liveEffects: props.track.liveEffects.effects && props.track.liveEffects.effects.length,
        _audioFx: props.track.effects,
        _midiFx: props.track.midiEffects,
        _liveFx: props.track.liveEffects,
        panning: state.tracks.trackPannings[props.track.trackNumber] || 0,
        pulledEffects: state.effects.pulledEffects
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedSteps: (steps) => dispatch(setSelectedPianoRollSteps(steps)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectsView);
